module.exports = __webpack_public_path__ + "img/fifa.ab75ce33.jpg";